export default __webpack_public_path__ + "static/Plots0027-fae1d6bd03bf42bc5730e61afd01bc9e.jpg";